(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-coordinate"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ap-pieces-carousel')) {
  customElements.define('ap-pieces-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.ap-pieces__track');
      this.cards = Array.from(this.querySelectorAll('.ap-pieces__slide'));
      this.status = this.querySelector('[data-position]');
      this.querySelector('[data-controls]').hidden = false;
      this.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
        this.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.cards.forEach(card => card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter);
        this.track.scrollTo({ left: 0, behavior: 'instant' });
        requestAnimationFrame(() => this.updatePosition());
      }, options));
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.step)), options));
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.updatePosition(), 180);
      }, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(() => this.updatePosition());
      this.resizeObserver.observe(this.track);
      this.updatePosition();
    }
    move(direction) {
      const items = this.cards.filter(card => !card.hidden);
      if (!items.length) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = items[0].getBoundingClientRect().width + gap;
      const page = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
      const end = this.track.scrollWidth - this.track.clientWidth;
      let target = this.track.scrollLeft + direction * step * page;
      if (direction > 0 && this.track.scrollLeft >= end - 10) target = 0;
      if (direction < 0 && this.track.scrollLeft <= 10) target = end;
      this.track.scrollTo({ left: Math.max(0, Math.min(end, target)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    updatePosition() {
      const items = this.cards.filter(card => !card.hidden);
      const rect = this.track.getBoundingClientRect();
      const visible = items.map((card, index) => ({ box: card.getBoundingClientRect(), index })).filter(item => item.box.left < rect.right - 8 && item.box.right > rect.left + 8);
      this.querySelectorAll('[data-step]').forEach(button => button.disabled = this.track.scrollWidth <= this.track.clientWidth + 4);
      const template = visible.length ? this.status.dataset.positionLabel : this.status.dataset.countLabel;
      const value = template.replace('__first__', String(visible[0]?.index + 1 || 1)).replace('__last__', String((visible.at(-1)?.index ?? 0) + 1)).replace('__count__', String(items.length));
      if (this.status.textContent !== value) this.status.textContent = value;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      clearTimeout(this.scrollTimer);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
